import { ReactFlowInstance, Node, Edge } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditFilterNode.id)) {
            newNodes.push(node);
        }
    }

    let edges: Edge[] = context.edges;
    let newEdges: Edge[] = [];
    for (const edge of edges) {
        if (!edge.id.includes(context.activeEditFilterNode.id)) {
            newEdges.push(edge);
        }
    }

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode: Node = context.activeEditFilterNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes: Node[] = reactFlowInstance.getNodes();
    let newNodes: Node[] = [];
    let activeIds: any[] = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
    ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [],
    properties: {
        'data_input': {
            title: 'Data Input',
            type: 'string',
            description: 'Location of data to filter',
            default: 'default'
        },
        data_input_key: {
            title: 'Data Input Key',
            type: 'string',
            description: 'Value to target data input values, use value_one/value_two for nested values'
        },

        filter_type: {
            title: 'Filter Data Type',
            type: 'string',
            enum: [
                'Text',
                'Number',
                'True/False',
                'Array',
                'Data Model',
            ],
            default: 'Text'
        },
        'data_management': {
            title: 'Data Store',
            type: 'string',
            description: 'Location to store results',
            default: 'default'
        },
        add_output_to_message: {
            title: 'Add Output To Messages',
            type: 'boolean',
            default: false,
            description: 'Store output as a message to keep in the message history as well as Data store',
        }
    },
    allOf: [
        {
            if: {
                properties: {
                    filter_type: {
                        const: 'Text'
                    }
                }
            },
            then: {
                properties: {
                    filter_condition_type: {
                        title: 'Filter Condition Type',
                        type: 'string',
                        enum: [
                            'AND',
                            'OR'
                        ],
                        default: 'AND'
                    },
                    text_filter_options: {
                        title: 'Text Filter Options',
                        type: 'array',
                        items: {
                            title: '',
                            type: 'object',
                            properties: {
                                text_operator: {
                                    title: 'Operator',
                                    type: 'string',
                                    enum: [
                                        'Is Empty',
                                        'Is not Empty',
                                        'Is Equal To',
                                        'Is not Equal To',
                                        'Contains',
                                        'Does not Contain',
                                        'Starts With',
                                        'Does Not Start With',
                                        'Ends With',
                                        'Does Not End With',
                                        'Matches Regex',
                                        'Does Not Match Regex'
                                    ]
                                },
                                text_filter_value: {
                                    title: 'Filter Value',
                                    type: 'string',
                                },
                            },
                            required: ['text_operator']
                        },
                    },
                },
            }
        },
        {
            if : {
                properties: {
                    filter_type: {
                        const: 'Number'
                    }
                }
            },
            then: {
                properties: {
                    filter_condition_type: {
                        title: 'Filter Condition Type',
                        type: 'string',
                        enum: [
                            'AND',
                            'OR'
                        ],
                        default: 'AND'
                    },
                    number_filter_options: {
                        title: 'Number Filter Options',
                        type: 'array',
                        items: {
                            title: '',
                            type: 'object',
                            properties: {
                                number_operator: {
                                    title: 'Operator',
                                    type: 'string',
                                    enum: [
                                        'Is Equal To',
                                        'Is not Equal To',
                                        'Is Greater Than',
                                        'Is Greater Than or Equal To',
                                        'Is Less Than',
                                        'Is Less Than or Equal To',
                                    ]
                                },
                                number_filter_value: {
                                    title: 'Filter Value',
                                    type: 'number',
                                },
                            },
                            required: ['number_operator']
                        },
                    },
                },
            }
        },
        {
            if : {
                properties: {
                    filter_type: {
                        const: 'Array'
                    }
                }
            },
            then: {
                properties: {
                    filter_condition_type: {
                        title: 'Filter Condition Type',
                        type: 'string',
                        enum: [
                            'AND',
                            'OR'
                        ],
                        default: 'AND'
                    },
                    array_filter_options: {
                        title: 'Array Filter Options',
                        type: 'array',
                        items: {
                            title: '',
                            type: 'object',
                            properties: {
                                array_operator: {
                                    title: 'Operator',
                                    type: 'string',
                                    enum: [
                                        'Is Empty',
                                        'Is not Empty',
                                        'Contains',
                                        'Does Not Contain',
                                        'Length Greater Than',
                                        'Length Greater Than or Equal To',
                                        'Length Less Than',
                                        'Length Less Than or Equal To',
                                    ]
                                },
                                array_filter_value: {
                                    title: 'Array Value',
                                    type: 'string',
                                },
                                // array_key: {
                                //     title: 'Array Key',
                                //     type: 'string',
                                //     description: 'Value to target array values, use value_one/value_two for nested values'
                                // },
                            },
                            required: ['array_operator']
                        },
                    },
                },
            }
        },
        {
            if: {
                properties: {
                    filter_type: {
                        const: 'True/False'
                    }
                }
            },
            then: {
                properties: {
                    true_false_filter_options: {
                        title: 'True/False Filter Options',
                        type: 'string',
                        enum: [
                            'Is True',
                            'Is False',
                        ]
                    }
                }
            }
        },
        {
            if : {
                properties: {
                    filter_type: {
                        const: 'Data Model'
                    }
                }
            },
            then: {
                properties: {
                    model_filter_option: {
                        title: 'Model Filter Option',
                        type: 'string',
                        enum: [
                            'Is Empty',
                            'Is not Empty',
                        ]
                    },
                },
            }
        },
        {
            if: {
                properties: {
                    data_management: {
                        const: 'messages'
                    }
                }
            },
            then: {
                properties: {
                    add_output_to_message: {
                        readOnly: true,
                    }
                }
            }
        }
    ]

}

export const nodeDescription: string = "This node is used to filter data arrays on a condition.\n" +
    "If the value exists, it will be added to the Data Store slot for the next node.\n";
